module.exports = __webpack_public_path__ + "img/company.e8179dd0.png";